const acordeon = (selector: string, unico: boolean = true) => {
    [].forEach.call(document.querySelectorAll(selector), (contenedor: HTMLDivElement) => {
        const botones: HTMLButtonElement[] = [].slice.call(contenedor.querySelectorAll<HTMLButtonElement>('[aria-controls]')),
            paneles: HTMLElement[] = botones.map(boton => document.getElementById(boton.getAttribute('aria-controls')!)!);

        const mostrar = (panel: HTMLElement): void => {
            panel.hidden = false;
            panel.setAttribute('aria-expanded', 'true');

            botones
                .filter(x => x.getAttribute('aria-controls') === panel.id)
                .forEach(x => x.setAttribute('aria-expanded', 'true'));
        };

        const ocultar = (panel: HTMLElement): void => {
            panel.hidden = true;
            panel.setAttribute('aria-expanded', 'false');
            botones
                .filter(x => x.getAttribute('aria-controls') === panel.id)
                .forEach(x => x.setAttribute('aria-expanded', 'false'));

            panel.closest('div')!.classList.remove('activo');
        }

        const abrePanel = (posicion: number) => {
            if (posicion >= 0) {
                if (paneles[posicion].hidden) {
                    mostrar(paneles[posicion]);
                } else {
                    ocultar(paneles[posicion]);
                }

                if (unico) {
                    paneles
                        .filter((panel, i) => i !== posicion && !panel.hidden)
                        .forEach(panel => ocultar(panel));
                }
            }
        }

        contenedor.addEventListener('click', e => {
            abrePanel(botones.indexOf(e.target as HTMLButtonElement));
        }, true);

        contenedor.addEventListener('keydown', e => {
            const boton = e.target as HTMLButtonElement;

            if (!boton || boton.nodeName !== 'BUTTON') {
                return;
            }

            switch (e.key) {
                case 'Space': {
                    abrePanel(botones.indexOf(boton));
                    break;
                }
                case 'ArrowDown': {
                    const siguiente = (botones.indexOf(boton) + 1) % botones.length;
                    botones[siguiente].focus();
                    e.preventDefault();
                    break;
                }
                case 'ArrowUp': {
                    const posicion = botones.indexOf(boton),
                        siguiente = posicion === 0 ? botones.length - 1 : posicion - 1;
                    botones[siguiente].focus();
                    e.preventDefault();
                    break;
                }
                case 'Home': {
                    botones[0].focus();
                    e.preventDefault();
                    break;
                }
                case 'End': {
                    botones[botones.length - 1].focus();
                    e.preventDefault();
                    break;
                }
            }
        }, true);
    });
}

export default acordeon;